const featuredProductsSlide = document.querySelector('.Featured-products__slider')

const updateBottomHeight = (heightZeroElement) => {
    const height = heightZeroElement.scrollHeight
    heightZeroElement.style.height = `${height}px`
}

const featuredProductsSwiper = new Swiper(featuredProductsSlide, {
    direction: 'horizontal',
    slidesPerView: 1.15,
    centeredSlides: true,
    spaceBetween: 20,
    slideToClickedSlide: true,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    init: false,
    breakpoints: {
        960: {
            slidesPerView: 2,
            initialSlide: 1       
        },
        1240: {
            slidesPerView: 3.5,
            initialSlide: 2       
        },
        1420: {
            slidesPerView: 5,
            initialSlide: 3       
        },
    },
    on: {
        slideChange: () => {
            const allSlides = featuredProductsSlide?.querySelectorAll('.swiper-slide')
            allSlides.forEach((slide) => {
                slide.querySelector('.js-featured-products-card-bottom').style.height = '0px'
            })
            const activeIndex = featuredProductsSwiper.realIndex
            const activeSlide = featuredProductsSwiper.slides[activeIndex]
            const hiddenContent = activeSlide.querySelector('.js-featured-products-card-bottom')
            updateBottomHeight(hiddenContent)
        }
    }
  });

  featuredProductsSwiper.init();